export default "__VITE_ASSET__BQcVweOA__"